import { useCallback } from 'react';

import { WaitlistFormController } from './WaitlistForm.types';
import { DAYS_OF_WEEK } from './fields/AllDaysPreferencesField/AllDaysPreferencesField.constants';

export const useDayPreferencesSync = (
   getValue: WaitlistFormController['getValue'],
   setValue: WaitlistFormController['setValue'],
   trigger: WaitlistFormController['trigger']
): VoidFunction => {
   return useCallback(() => {
      const dayTimePreferences = getValue('dayTimePreferences');
      const allDaysPreferences = getValue('allDaysPreferences');
      const values = Object.values(dayTimePreferences);

      const notEmptyPreferencesCount = values.filter((preferences) => preferences.length > 0).length;
      const preferencesCount = values.length;
      const nextAllDaysPreferences = notEmptyPreferencesCount === preferencesCount;

      if (allDaysPreferences !== nextAllDaysPreferences) {
         setValue('allDaysPreferences', nextAllDaysPreferences);
      }

      setValue('dayTimePreferencesValidation', notEmptyPreferencesCount === 0, { shouldValidate: true });
      trigger(DAYS_OF_WEEK.map((day) => `dayTimePreferences.${day}`));
   }, [getValue, setValue, trigger]);
};
